module.exports = __webpack_public_path__ + "static/media/qrCodeArrowLeft.svg";